<template>
    <!-- wrapper div needed, otherwise parent.$refs is incorrect, see: https://github.com/vuejs/vue/issues/5997-->
    <div>
        <loading v-if="loading"></loading>
        <div v-else-if="!submissions">
            Nog geen reflectie beschikbaar.
        </div>
        <div v-else>

            <h2>Dit heeft een klasgenoot gemaakt:</h2>

            <template v-if="type === 'Upload'">
                <upload :submissions="submissions"></upload>
            </template>

            <template v-else>
                <question v-for="submission in submissions" :submissions="[submission]" :key="submission.id"></question>
            </template>

        </div>
    </div>
</template>


<script>

import { setValidation } from 'js/vuex/actions';
import { transform } from 'js/vuex/helpers';
import api from 'js/api/resources'
import track from 'js/helpers/analytics';

import Loading from 'js/components/elements/Loading.vue';
import Question from 'js/components/assignment/presenters/Question.vue';
import Upload from 'js/components/assignment/presenters/Upload.vue';


export default {
    components: { Question, Upload, Loading },
    props: {
        partial: {},
        progress: {},
    },

    data: function() {
        return {
            loading: false,
            submissions: null,
            user: null,
        }
    },

    vuex: {
        getters: {
        },
        actions: {
            setValidation
        }
    },

    computed: {
        type: function() {

            const submission = this.submissions[0]

            if ( submission.data instanceof Object && submission.data.medium != null && submission.data.thumb != null) {
                return 'Upload'
            }

            return 'Question'

        },
    },

    methods: {
        flush: function() {
            return Promise.resolve()
        },
    },

    created: function() {

        this.loading = true

        const getter = this.progress.fake ?  api.getFallbackReflectionSubmission(this.progress.assignment) : api.getReflectionSubmission(this.progress.id)

        getter
            .then( response => transform(response.body) )
            .then( result => {
                this.submissions = result.submissions
                this.user = result.users[0]
            })
            .then( () => this.setValidation(this.partial.id, true) )
            .catch( err => track.exception('Can\'t load reflection ', err))
            .then( () => this.loading = false )

    }
}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// ReflectionPartial.vue?79a99bac